var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgManagercomponent = function SvgManagercomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9c2.525 0 4.571-2.014 4.571-4.5S10.525 0 8 0 3.429 2.014 3.429 4.5 5.475 9 8 9Zm3.421 1.146-1.707 6.729-1.143-4.781 1.143-1.969H6.286l1.143 1.969-1.143 4.781-1.707-6.729C2.032 10.266 0 12.316 0 14.85v1.463C0 17.244.768 18 1.714 18h12.572c.946 0 1.714-.756 1.714-1.688V14.85c0-2.535-2.032-4.584-4.579-4.704Z",
    fill: "#CECCC9"
  })));
};
export default SvgManagercomponent;